type ResolveEFinderImageSourceParams = {
  url: string;
  contentType?: string;
  requestedHeight?: number;
  attachmentHeight?: number;
};

const SIGNED_URL_QUERY_KEYS = [
  'Expires',
  'Signature',
  'Key-Pair-Id',
  'Policy',
] as const;

export const isCloudFrontSignedUrl = (url: string): boolean => {
  try {
    const searchParams = new URL(url).searchParams;
    return SIGNED_URL_QUERY_KEYS.some((key) => searchParams.has(key));
  } catch {
    return false;
  }
};

export const resolveEFinderImageSource = ({
  url,
  contentType,
  requestedHeight,
  attachmentHeight,
}: ResolveEFinderImageSourceParams): string => {
  if (
    contentType === 'image/gif' ||
    requestedHeight === undefined ||
    isCloudFrontSignedUrl(url)
  ) {
    return url;
  }

  const height = attachmentHeight
    ? Math.min(requestedHeight, attachmentHeight)
    : requestedHeight;
  const separator = url.includes('?') ? '&' : '?';

  return `${url}${separator}t=h&d=${height}`;
};
